// routes
import Router from "./routes";
// theme
import ThemeConfig from "./theme";
// components
import ScrollToTop from "./components/ScrollToTop";
import MyAlert from "./components/common/MyAlert";
import { IS_TEST } from "./config/constants";

// ----------------------------------------------------------------------

export default function App() {
  return (
    <ThemeConfig>
      <ScrollToTop />
      <Router />
      <MyAlert />
      {IS_TEST && (
        <img
          src="/admin/static/test.png"
          style={{
            position: "fixed",
            top: 60,
            right: 100,
            width: 400,
            height: 400,
            opacity: 0.08,
            pointerEvents: "none",
          }}
        />
      )}
    </ThemeConfig>
  );
}
